import script from "./BpmnSpeed.vue?vue&type=script&setup=true&lang=js"
export * from "./BpmnSpeed.vue?vue&type=script&setup=true&lang=js"

import "./BpmnSpeed.vue?vue&type=style&index=0&id=7234a7fa&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/zh-workflow-frontend_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7234a7fa"]])

export default __exports__